<template>

  <div class="button-modern" @click="$emit('click')"></div>

</template>

<script>

export default {

  name: 'ButtonModern',
}

</script>

<style lang="sass">

.button-modern
  width: 114px
  height: 114px

  background-color: #000000
  box-shadow: 0px 2.9703px 2.9703px rgba(0, 0, 0, 0.25)
  border-radius: 71.8812px

  background-size: 60%
  background-position: center
  background-repeat: no-repeat
  position: absolute
  margin-bottom: -90px
  bottom: 0
  cursor: pointer

  &_true
    left: 25px
    border: 2px solid #B0F80C
    background-image: url(../assets/img/true.svg)

    &:active
      box-shadow: none
      background-color: #B0F80C
      background-image: url(../assets/img/true_active.svg)

  &_false
    right: 25px
    border: 2px solid #D357FF
    background-image: url(../assets/img/false.svg)

    &:active
      box-shadow: none
      background-color: #D357FF
      background-image: url(../assets/img/false_active.svg)

@media (max-width: 420px)
  .button-modern
    width: 30vw
    height: 30vw
    margin-bottom: -23vw
    bottom: 0

    &_true
      left: 5.5vw

    &_false
      right: 5.5vw
</style>
